import { render, staticRenderFns } from "./WendaOption.vue?vue&type=template&id=53f13eac&"
import script from "./WendaOption.vue?vue&type=script&lang=js&"
export * from "./WendaOption.vue?vue&type=script&lang=js&"
import style0 from "./WendaOption.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports